import { GraphQLError } from "graphql";

import { SentryLoggable } from "../SentryLoggable";

interface RelatedErrors {
  stripeError?: stripe.Error;
  graphQLErrors?: GraphQLError[];
}

abstract class SetupIntentError extends Error {
  protected stripeError: stripe.Error | undefined;
  protected graphQLErrors: GraphQLError[] | undefined;

  protected constructor(
    message: string,
    { stripeError, graphQLErrors }: RelatedErrors
  ) {
    super(message);
    this.stripeError = stripeError;
    this.graphQLErrors = graphQLErrors;
  }
}

class SetupIntentConfirmationError
  extends SetupIntentError
  implements SentryLoggable
{
  transactionName = "setupIntent.confirm";

  constructor(message: string, stripeError?: stripe.Error) {
    super(message, { stripeError });
  }
}

class SetupIntentCreationError
  extends SetupIntentError
  implements SentryLoggable
{
  name = "SetupIntentCreationError";
  transactionName = "setupIntent.create";

  constructor(message: string, graphQLErrors?: GraphQLError[]) {
    super(message, { graphQLErrors });
  }
}

export { SetupIntentConfirmationError, SetupIntentCreationError };
